// src/pages/FormationPages/GestionDesProjets.js
import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './gestiondesprojets.css'; // Import the CSS file
import { useNavigate } from 'react-router-dom';

// Sample data for the trainings
const trainings = [
    {
        id: 'project-management-introduction',
        title: 'Gestion de Projet Agile: Méthode Scrum',
        details: [
            { 
                detail: "Description", 
                description: "Les méthodes Agiles, et en particulier Scrum, sont devenues le nouveau standard de gestion des projets de développement. Elles permettent de mieux maîtriser les délais, les coûts tout en augmentant la qualité des produits."
            },
            { 
                detail: "Objectives", 
                description: (
                    <p>
                        • Connaître les principes, les valeurs et les avantages de la méthode Scrum <br />
                        • Connaître les rôles de la méthode Scrum et leurs responsabilités associées <br />
                        • Être en mesure de développer le backlog du produit et de planifier les releases du produit <br />
                        • Être en mesure de mettre efficacement en œuvre la planification, la réalisation, la revue et la rétrospective des sprints
                    </p>
                )
            },
        ]
    },
    {
        id: 'agile-methodologies',
        title: 'Fondamentaux de la Gestion de Projet',
        details: [
            { 
                detail: "Description", 
                description: "Développez et approfondissez vos compétences en gestion de projet. Une gestion de projet efficace permet de mieux maîtriser les délais, les coûts tout en augmentant la qualité des produits."
            },
            { 
                detail: "Objectives", 
                description: (
                    <p>
                       • Assimiler les différentes phases de la conduite d’un projet de la phase d’étude à la clôture du projet<br/>
                       • Savoir organiser un projet, connaitre la gouvernance du projet les acteurs et leurs contributions<br/>
                       • Assimiler et être en mesure d’utiliser les méthodes et outils de la gestion de projet<br/>
                       • Connaitre et être en mesure de gérer les défis et les risques inhérents à la conduite d’un projet<br/>
                    </p>
                )
            },
        ]
    }
];

const GestionDesProjets = () => {
    const [selectedTraining, setSelectedTraining] = useState(null);
    const navigate = useNavigate(); // Navigation hook

    // Function to handle detail view
    const handleDetailsView = (training) => {
        setSelectedTraining(training);
    };

    // Function to go back to the catalog
    const handleBackToCatalog = () => {
        setSelectedTraining(null);
    };

    // Render the catalog view
    const renderCatalog = () => (
        <div className="training-catalog">
            <h1 className="catalog-title">Formations - Gestion des projets</h1>
            <div className="training-list">
                {trainings.map((training) => (
                    <div key={training.id} className="card-centered shadow">
                        <h3 className="card-title">{training.title}</h3>
                        <p className="card-description">{training.description}</p>
                        <button 
                            onClick={() => handleDetailsView(training)} 
                            className="btn btn-primary"
                        >
                            En savoir plus
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );

    // Render the details view
    const renderDetails = () => (
        <div className="container mt-5">
            <button className="btn btn-secondary mb-4" onClick={handleBackToCatalog}>
                Retour au Catalogue
            </button>
            
            <table className="details-table">
                <thead>
                    <tr>
                        <th colSpan="2" className="details-title">{selectedTraining.title}</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedTraining.details.map((detail, index) => (
                        <tr key={index}>
                            <td>{detail.detail}</td>
                            <td>{detail.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Participer button */}
            <div className="text-center mt-4">
                <button
                    className="btn btn-success"
                    onClick={() =>
                        navigate('/contact', { state: { training: selectedTraining.title } })
                    }
                >
                    Participer
                </button>
            </div>
        </div>
    );

    return (
        <div className="min-vh-100">
            <Header />
            {selectedTraining ? renderDetails() : renderCatalog()}
            <Footer />
        </div>
    );
};

export default GestionDesProjets;